import { render, staticRenderFns } from "./BadgeIcon.vue?vue&type=template&id=53e0478d&scoped=true&"
import script from "./BadgeIcon.vue?vue&type=script&lang=js&"
export * from "./BadgeIcon.vue?vue&type=script&lang=js&"
import style0 from "./BadgeIcon.vue?vue&type=style&index=0&id=53e0478d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e0478d",
  null
  
)

export default component.exports